import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Row as BasicRow } from '@/components/Row';

export const Desc = styled(Box)`
  text-align: center;
  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(2)};
    color: ${theme.colors.default};
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.p2};
  `}
`;

export const Row = styled(BasicRow)`
  ${({ theme }) => css`
    margin: ${theme.spacing(2)};
    grid-gap: ${theme.spacing(2)};
  `}
`;
